import { render } from "./LearningCycleCard.vue?vue&type=template&id=067b8814&scoped=true"
import script from "./LearningCycleCard.vue?vue&type=script&lang=js"
export * from "./LearningCycleCard.vue?vue&type=script&lang=js"

import "./LearningCycleCard.vue?vue&type=style&index=0&id=067b8814&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-067b8814"]])

export default __exports__